import React from 'react'
import { Field } from '@ztechapps/webui.form'
import { ProductSelect, QuantityInputWithUom } from '@ztechapps/product.webui'
import { Stack } from 'react-bootstrap'
import { useFormikContext } from 'formik'
import type { WorkOrderAddFormValues } from './Context'

export const WorkOrderAddFormInput = () => {
  const { values } = useFormikContext<WorkOrderAddFormValues>()
  const uomSymbol = values?.product?.baseUom?.symbol

  return (
    <Stack gap={3}>
      <div>
        <Field label="Product to produce" name="product" component={ProductSelect} onChange autoFocus />
      </div>
      <div>
        <Field
          label="Quantity to produce"
          name="quantity"
          min={1}
          component={QuantityInputWithUom}
          symbol={uomSymbol}
        />
      </div>
    </Stack>
  )
}
